angular.module('hjApp').service('ModalBillingWarning', [
    '$modal',
    function ($modal) {
        /**
         * Show a billing waning modal.
         *
         * @param {string} warningType Type of warning we are showing.
         * @param {object} warningData Data needed for the modal.
         */
        this.show = function (warningType, warningData) {
            // Do not proceed if we don't have all the data we need.
            if (
                _.isUndefined(warningType) ||
                _.isUndefined(warningData) ||
                _.isUndefined(warningData.account) ||
                _.isUndefined(warningData.subscriptionInfo)
            ) {
                throw new Error(
                    'ModalBillingWarning.show(): You must specify (pass) warningType and warningData ' +
                        'which is an object containing account and subscriptionInfo.'
                );
            }

            return $modal.open({
                templateUrl: 'modal_billing_warning.html',
                controller: 'ModalBillingWarning',
                controllerAs: 'ctrl',
                backdrop: 'static',
                windowClass: 'modal-500 modal-billing-warning',
                resolve: {
                    warningData: _.wrap(warningData),
                    warningType: _.wrap(warningType)
                }
            });
        };
    }
]);
